//フォーム
window.onload = function() {
  //該当フォーム
  $('.mw_wp_form form').attr('class', 'h-adr');
  new YubinBango.MicroformatDom();
  if(document.querySelector('.h-adr')) {
    const hadr = document.querySelector(".h-adr");
    let cancelFlag = true;
    
    //イベントをキャンセル
    const onKeyupCanceller = function (e) {
      if (cancelFlag) {
        e.stopImmediatePropagation();
      }
      return false;
    };
    // 郵便番号の入力欄
    const postalcode = hadr.querySelectorAll(".p-postal-code"),
    postalField = postalcode[postalcode.length - 1];

    //通常の挙動をキャンセルできるようにイベントを追加
    postalField.addEventListener("keyup", onKeyupCanceller, true);

    //ボタンクリック時
    const btn = hadr.querySelector(".postal-search");
    btn.addEventListener("click", function (e) {
    //キャンセルを解除
    cancelFlag = false;

    //処理実行
    let event;
    if (typeof Event === "function") {
      event = new Event("keyup");
    } else {
      event = document.createEvent("Event");
      event.initEvent("keyup", true, true);
    }
    postalField.dispatchEvent(event);

    //キャンセルを戻す
    cancelFlag = true;
    });
  }
};

//ページ内リンク
jQuery(window).on('load', function() {
  let headerHeight = $('header').outerHeight();
  let urlHash = location.hash;
  if (urlHash) {
    let position = $(urlHash).offset().top - headerHeight;
    $('html, body').animate({ scrollTop: position }, 0);
  }
});

jQuery(function ($) {

  //フォーム
  $('.mw_wp_form_preview .form-content__progress li').removeClass('is-current');
  $('.mw_wp_form_preview .form-content__progress li:nth-of-type(2)').addClass('is-current');
  $('.c-type02_child input').prop({'disabled':true});
  $('.c-type03_child input').prop({'disabled':true});
  $('.c-type02 input').change(function(){
    if($('.c-type02 input').prop("checked") == true){
      $('.c-type02_child input').prop({'disabled':false});
    } else{
      $('.c-type02_child input').prop({'disabled':true});
      $('.c-type02_child input').removeAttr("checked").prop("checked", false).change();;
    }
  });
  $('.c-type03 input').change(function(){
    if($('.c-type03 input').prop("checked") == true){
      $('.c-type03_child input').prop({'disabled':false});
    } else{
      $('.c-type03_child input').prop({'disabled':true});
      $('.c-type03_child input').removeAttr("checked").prop("checked", false).change();;
    }
  });

  //トップトピックスタブ切り替え
  const $js_tab = $('.topics-list__top .topics-list__cat__item');
  const $js_tab_target = $('.topics-list__top .topics-list__content');
  const cls = 'is-active';

  $js_tab.on('click', function () {
    const this_category = $(this).data('category');
    $js_tab.removeClass(cls);
    $(this).addClass(cls);
    $js_tab_target.removeClass(cls);
    $js_tab_target.each(function () {
      const target_data = $(this).data('target');
      if (this_category === target_data) {
        $(this).addClass(cls);
      }
    });
  });

  //トピックスカテゴリーページアクティブ切り替え
  if (window.matchMedia('(min-width: 768px)').matches) {
  const nowPage = location.pathname;
  const $topicsCat = $('#category-info .topics-list__cat__item');
  $topicsCat.removeClass('is-active');
  }

  //ページ内リンク
  $('a[href^="#"]').on('click', function () {
    let time = 400;
    let header = $('header').height();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({
      scrollTop: targetY
    }, time, 'swing');
    return false;
  });

  //トップへ戻る
  var pagetop = $('.footer-pagetop');
  pagetop.click(function () {
    $('body, html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });

  //カンパニーナビ:アクティブクラス付与
  var href = location.href;
  var segment = href.match(/([^\/]*)\/*$/)[1];
  var listItem = $('.corporate-nav__list__item');

  listItem
    .filter(
        function(){
            return($(this).data('slug') === segment);
        }
    ).addClass('is-active');
  
  //カンパニーナビ：現在地
  if(document.querySelector('.corporate-nav__list')) {
    var $scrollSec = $('.corporate-nav__list');
    var $activeItem = $('.corporate-nav__list__item.is-active');
    var $activeItemPos = $activeItem.offset().left;
    $scrollSec.scrollLeft($activeItemPos);
  }

  //infoナビ:アクティブクラス付与
  var href = location.href;
  var segment = href.match(/([^\/]*)\/*$/)[1];
  var listItem = $('.topics-list__cat__item');

  listItem
    .filter(
        function(){
            return($(this).data('slug') === segment);
        }
    ).addClass('is-active');

  //トップバナースライダー
  if (window.matchMedia('(min-width: 768px)').matches) {
    var mainHeight = $('.fv-bottom').height();
    var slideHeight = mainHeight*58/100;
    $('.top-bnr__list__item').css('height', slideHeight);
    $(".top-bnr__list").slick({
      arrows: true,
      autoplay: false,
      // autoplaySpeed: 3000,
      slidesToShow: 3,
      infinite: true,
    });
  } else {
    $(".top-bnr__list").slick({
      arrows: true,
      autoplay: false,
      centerMode: true,
      centerPadding: "13%",
      autoplaySpeed: 3000,
      // slidesToShow: 1,
      infinite: true,
    });
  }

  //トップ導入事例スライダー
  $('.case-list__item__tag').matchHeight();
  if (window.matchMedia('(min-width: 768px)').matches) {
    $(".case-list__slider .case-list").slick({
      // variableWidth: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      infinite: true,
    });
  } else {
    $(".case-list__slider .case-list").slick({
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      centerMode: true,
      centerPadding: "15%",
      infinite: true,
      useTransform: false
    });
  }

  //トップイベントスライダー
  var itemNum = $('#top .event-list .event-list__item').length;
  if(itemNum >= 4){
    $('#top .event-list').addClass('is-slide');
  }
  if (window.matchMedia('(min-width: 768px)').matches) {
    $("#top .event-list.is-slide").slick({
      // variableWidth: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      infinite: false,
    });
  } else {
    $("#top .event-list.is-slide").slick({
      // variableWidth: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      // slidesToShow: 1,
      centerMode: true,
      centerPadding: "15%",
      infinite: true,
      useTransform: false
    });
  }

  //ハンバーガーメニュー
  $('.header-hamburger').on('click', function () {
    $('.header-hamburger').toggleClass('is-active');
    $('.header-nav').toggleClass('is-active');
    $('header').toggleClass('is-active');
    $('body').toggleClass('js-nav__active');
  });

  $('.header-nav__item a').on('click', function () {
    $('.header-hamburger').removeClass('is-active');
    $('.header-nav').removeClass('is-active');
    $('header').removeClass('is-active');
    $('body').removeClass('js-nav__active');
  });


  //製品モーダル
  if (window.matchMedia('(max-width: 768px)').matches) {
    $('.modal-anchor').on('click',function(){
      $(this).children('.product-cat__list__item__hover').addClass('is-shown');
    });

    $('.close').on('click', function(){
      $('.product-cat__list__item__hover').removeClass('is-shown');
      return false;
    });
  }

  $('.reset').on('click', function(){
    $('.case-sort input').removeAttr("checked").prop("checked", false).change();
  });

  $('.search-page .reset').on('click', function(){
    window.location.href = "/case/#searchform";
    console.log('reset');
  });

  //xtrek タブ切り替え
  $('.tab-list li').on('click', function() {
    $('.tab-list li').removeClass('is-active');
    $(this).addClass('is-active');
    $('.tab-content').removeClass('is-active');   
    var index = $('.tab-list li').index(this);
    $('.tab-content').eq(index).addClass('is-active');
  });


  let url = location.href;
  var result = url.indexOf('/case/?s=');
  if(result !== -1) {
    $(window).scrollTop($('#case-main').position().top);
  }

});

  /* dropdown
============================================================================================================ */
jQuery(document).on('click', function(e) {
  if(!$(e.target).closest('.dropdown-menu').length && !$(e.target).closest('.dropdown').length){
      $('.dropdown-menu').fadeOut();
  }else if($(e.target).closest('.dropdown').length){
      if($('.dropdown-menu').is(':hidden')){
          $('.dropdown-menu').fadeIn();
      }else{
          $('.dropdown-menu').fadeOut();
      }
  }
});